module.exports = __webpack_public_path__ + "static/media/lena_music_sequencer.73bcbc40.png";